import { BASE_URL } from "consts/APIUrls";
import useProfile from "hooks/useProfile";
import React, { useEffect, useState } from "react";
import { createAPI } from "services/api/api";

const BuyWidget = () => {
  const api = createAPI();
  const { email, user_wallet } = useProfile();
  const [signedPayload, setSignedPayload] = useState("");

  useEffect(() => {
    if (!user_wallet) return;

    const payload = `wallets=usdc_polygon:${user_wallet}`;

    api
      .post(`${BASE_URL}/onramper/sign`, {
        data: payload,
      })
      .then((res) => res.data)
      .then(({ signature }) => {
        setSignedPayload(
          `&email=${encodeURIComponent(
            email
          )}&${payload}&signature=${signature}`
        );
      })
      .catch(console.error);
  }, [user_wallet]);

  const apiKey =
    window.location.origin === "https://game.twotwentyk.io" || 'https://stage.twotwentyk.io/'
      ? "pk_prod_01K18VWSV2NNYSVHFGWMNT2YKE"
      : "pk_test_01K0PH6P2NZMKJMQ4DC375R0QD";

   const iframeSrc = `https://buy.onramper.com/?apiKey=${apiKey}&mode=buy&onlyOnramps=banxa,topper,coinbasepay,gatefi,onrampmoney&
   defaultCrypto=usdc_polygon&onlyCryptos=usdc_polygon&defaultFiat=usd
   &onlyFiats=usd&defaultAmount=100&defaultPaymentMethod=debitcard&onlyCryptoNetworks=polygon&themeName=dark${signedPayload}`;

  return (
    <iframe
      src={iframeSrc}
      title="Onramper Widget Buy"
      width="100%"
      height="630px"
      style={{
        flexShrink: 0,
        width: '438px',
        height: "630px",
        border: "none",
      }}
      allow="accelerometer; autoplay; camera; gyroscope; payment; microphone"
    />
  );
};

export default BuyWidget;
